import React, { useState, useEffect } from 'react'
import { 
  ArrowLeft,
  Edit
} from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import { useNavigate, useLocation } from 'react-router-dom'

const PaymentTermsMasterView = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const paymentTermsData = location.state?.paymentTermsData || {}

  const [formData, setFormData] = useState({
    paymentTermsCode: '',
    order: '',
    description: '',
    status: 'Active'
  })

  // Pre-fill form data when component mounts
  useEffect(() => {
    setFormData({
      paymentTermsCode: paymentTermsData.paymentTermsCode || '',
      order: paymentTermsData.order || '',
      description: paymentTermsData.description || '',
      status: paymentTermsData.status || 'Active'
    })
  }, [paymentTermsData])

  const handleBack = () => {
    navigate('/sales/payment-terms-master')
  }

  const handleEdit = () => {
    navigate('/sales/payment-terms-master/edit', { state: { paymentTermsData } })
  }

  // Breadcrumb items
  const breadcrumbItems = [
    {
      label: 'Sales',
      path: '/sales',
      onClick: () => navigate('/sales')
    },
    {
      label: 'Masters',
      path: '/sales',
      onClick: () => navigate('/sales')
    },
    {
      label: 'Payment Terms Master',
      path: '/sales/payment-terms-master',
      isCurrent: true
    }
  ]

  return (
    <div className="sales-dashboard">
      {/* Breadcrumb Navigation */}
      <div className="breadcrumb-section">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      {/* Page Header */}
      <div className="page-header">
        <div className="page-title">
          <h1>Payment Terms Master - View</h1>
          <p>View payment terms master data</p>
        </div>
        <div className="page-actions">
          <button className="btn-primary" onClick={handleEdit}>
            <Edit size={18} />
            Edit
          </button>
        </div>
      </div>

      {/* Form Section */}
      <div className="form-container">
        <div className="sac-form-header">
          <h2>Payment Terms Master</h2>
        </div>
          
        <form className="form-content">
          {/* Row 1: Payment Terms Code, Order, Description, Status */}
          <div className="grid-row-4">
            <div className="form-group">
              <label htmlFor="paymentTermsCode" className="form-label required">
                Payment Terms Code
              </label>
              <input
                type="text"
                id="paymentTermsCode"
                name="paymentTermsCode"
                value={formData.paymentTermsCode}
                readOnly
                className="form-input readonly-input"
                placeholder="Enter payment terms code"
              />
            </div>

            <div className="form-group">
              <label htmlFor="order" className="form-label required">
                Order
              </label>
              <input
                type="number"
                id="order"
                name="order"
                value={formData.order}
                readOnly
                className="form-input readonly-input"
                placeholder="Enter order number"
                min="1"
                step="1"
              />
            </div>

            <div className="form-group">
              <label htmlFor="description" className="form-label required">
                Description
              </label>
              <input
                type="text"
                id="description"
                name="description"
                value={formData.description}
                readOnly
                className="form-input readonly-input"
                placeholder="Enter description"
              />
            </div>

            <div className="form-group">
              <label htmlFor="status" className="form-label required">
                Status
              </label>
              <input
                type="text"
                id="status"
                name="status"
                value={formData.status}
                readOnly
                className="form-input readonly-input"
                placeholder="Status"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PaymentTermsMasterView